import { render, staticRenderFns } from "./DevelopmentView.vue?vue&type=template&id=5e6c6f41&"
import script from "./DevelopmentView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DevelopmentView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports